import { ReactNode } from "react";
import { Col, Row, Space, Typography, theme } from "antd";
import ExclamationCircleOutlined from "@ant-design/icons/ExclamationCircleOutlined";

import { Wrapper } from "./styles";

export type ErrorScreenProps = {
  title?: string;
  subtitle?: string;
  children?: ReactNode;
};

export const ErrorScreen = ({
  title,
  subtitle,
  children,
}: ErrorScreenProps) => {
  const { token } = theme.useToken();

  return (
    <Wrapper>
      <Space direction="vertical" size="large">
        <Row gutter={[24, 24]}>
          <Col>
            <ExclamationCircleOutlined
              style={{ color: token.colorPrimary, fontSize: 72 }}
            />
          </Col>
          <Col>
            {title && (
              <Typography.Title
                level={2}
                style={{
                  fontWeight: "normal",
                  color: token.colorPrimary,
                  margin: 0,
                }}
              >
                {title}
              </Typography.Title>
            )}
            {subtitle && (
              <Typography.Title
                level={4}
                style={{
                  fontWeight: "normal",
                  color: token.colorTextDescription,
                  margin: 0,
                }}
              >
                {subtitle}
              </Typography.Title>
            )}
          </Col>
        </Row>
        {children}
      </Space>
    </Wrapper>
  );
};
